import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
} from "react";
import { ListarClientesController } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    Produto,
    Unidade,
} from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { useForm } from "react-hook-form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { VincularClienteEmailTriagemController } from "../../../../Controllers/Geral/Triagem/TriagemControllers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { IBlacklistEmail } from "../../../../Interfaces/Geral/Triagem";
import Select, { ActionMeta, SingleValue } from "react-select";

interface IVincularClienteOuUnidade {
    setShow: Dispatch<SetStateAction<boolean>>;
    idEmail: number;
    ListarEmailsBlacklist: () => Promise<IBlacklistEmail[]>;
}

export default function VincularClienteOuUnidade(
    props: IVincularClienteOuUnidade
) {
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState<string>("");
    const [unidade, setUnidade] = useState<Unidade[]>([]);
    const [idCliente, setIdCliente] = useState<number>();
    const [optionsCliente, setOptionsCliente] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [isClientSelected, setIsClientSelected] = useState<boolean>(true);

    const { handleSubmit, register } = useForm();

    const {
        execute: VincularClienteEmailTriagem,
        loading: VincularClienteEmailTriagemLoading,
    } = useAsyncCallback(VincularClienteEmailTriagemController);

    const handleVincularContaOuUnidade = (formData: { ID_UNIDADE: number }) => {
        if (!idCliente) {
            setIsClientSelected(false);
            return;
        }
        VincularClienteEmailTriagem(
            idCliente ?? 0,
            props.idEmail ?? 0,
            formData.ID_UNIDADE ?? 0
        ).then(() => {
            props.setShow(false);
            props.ListarEmailsBlacklist();
        });
    };

    const { value: lstClientes, loading: lstClientesLoading } =
        useAsyncEffect(() => {
            return ListarClientesController(0, 0, {
                ID_EMPREENDIMENTO: [],
                ID_UNIDADE: 0,
            });
        }, []);

    const handleClientChange = (
        option: SingleValue<any>,
        actionMeta: ActionMeta<any>
    ) => {
        const client = lstClientes?.LISTA_CLIENTES.find(
            (cliente) => cliente.ID_CONTA === option?.value
        );
        setProdutos(client ? client.PRODUTOS : []);
        setProdutoSelecionado("");
        setUnidade([]);
        setIdCliente(option?.value);
        setIsClientSelected(!!option);
    };

    const handleProductChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const productId = e.target.value;
        setProdutoSelecionado(productId);
        const product = produtos.find(
            (product) => product.ID_PRODUTO.toString() === productId
        );
        setUnidade(product ? product.UNIDADES : []);
    };

    useEffect(() => {
        setOptionsCliente(() =>
            lstClientes?.LISTA_CLIENTES?.map((cliente) => ({
                label: cliente.DS_CONTA,
                value: cliente.ID_CONTA,
            }))
        );
    }, [lstClientes?.LISTA_CLIENTES]);

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    return (
        <OrSpinner loading={lstClientesLoading} spinner="capys">
            <div className="row">
                <form
                    onSubmit={handleSubmit(handleVincularContaOuUnidade)}
                    className="col-12"
                >
                    <h1 className="text-center">
                        Vincular Conta ou Unidade ao Email
                    </h1>

                    <label>Cliente</label>
                    <Select
                        name="ID_CONTA"
                        options={optionsCliente}
                        onChange={handleClientChange}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={"Selecione um cliente"}
                        noOptionsMessage={() => "Nenhuma opção"}
                        className="mb-2"
                    />
                    {!isClientSelected && (
                        <p className="text-danger">Este campo é obrigatório.</p>
                    )}

                    {produtos && produtos.length > 0 && (
                        <div className="form-group">
                            <label htmlFor="ID_PRODUTO">Empreendimento</label>
                            <select
                                name="ID_PRODUTO"
                                id="ID_PRODUTO"
                                onChange={handleProductChange}
                                value={produtoSelecionado}
                                className="form-control"
                            >
                                <option value=""></option>
                                {produtos.map((product) => (
                                    <option
                                        key={product.ID_PRODUTO}
                                        value={product.ID_PRODUTO.toString()}
                                    >
                                        {product.DS_PRODUTO}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {unidade && unidade.length > 0 && (
                        <div className="form-group">
                            <label htmlFor="ID_UNIDADE">Unidade</label>
                            <select
                                name="ID_UNIDADE"
                                id="ID_UNIDADE"
                                className="form-control"
                                ref={register()}
                            >
                                <option value=""></option>
                                {unidade.map((unit) => (
                                    <option
                                        key={unit.ID_UNIDADE}
                                        value={unit.ID_UNIDADE.toString()}
                                    >
                                        {unit.DS_UNIDADE}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="d-flex justify-content-end">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={VincularClienteEmailTriagemLoading}
                        >
                            {VincularClienteEmailTriagemLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faPaperPlane} />
                            )}{" "}
                            Vincular
                        </button>
                    </div>
                </form>
            </div>
        </OrSpinner>
    );
}
